/*
  * dirty hack
  * Problem here is https://github.com/wkda/auto1-platform/blob/master/themes/mars/js/app/app.section-scroller.js#L9
  * The page scrolls to the top after loading despite the anchor.
  * We can't change this because our Legacy has been frozen.
  * The code below scrolls to the anchor after the page is scrolled to the top
  * */
export const scrollToAnchorHack = (): void => {
  setTimeout(() => {
    const hash = location.hash.replace('#', '')
    const el = document.getElementById(hash)
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }, 1000)
}
